import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fab,
  FormControl,
  FormControlLabel,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  makeStyles,
  Radio,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import React, { useEffect, useMemo, useState, useRef } from "react";
import _, { update } from "lodash";
import Moment from "moment";
import { useReactToPrint } from "react-to-print";
import { invTemp as invoiceTemplate } from "../../assets/html/invTemp";
import { challan2Template } from "../../assets/html/challan2Template";
import { challan3Template } from "../../assets/html/challan3Template";
import { dataURItoBlob, htmlTemplateToDataString } from "../../utils";
import { formatINR0 } from "../../utils/money";
import { CloudDownload, CloudUpload, Receipt } from "@material-ui/icons";
import * as XLSX from "xlsx";
import { ImportExcel } from "../Master/ImportExcel";
import { Tooltip } from "@material-ui/core";
import AccountView from "../Account/AccountView";
import AccountAddress from "../Account/accountAddress";
import PrintIcon from "@mui/icons-material/Print";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";

import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import AddIcon from "@material-ui/icons/Add";
import axios from "axios";
import {
  baseUrl,
  GenerateChallanThermalMultiPDFAPI,
  DeleteChallanAPI,
  GetAllBanksAPI,
  GetAllChallansAPI,
  GetAllPrintAdsAPI,
  GetEntityAPI,
  GetAllLedgersAPI,
  GetAccountAPI,
} from "../../config/api";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ChallanView from "./ChallanView";
import ChallanAddDialog from "./ChallanAddDialog";
import ChallanEditDialog from "./ChallanEditDialog";

import { extendMoment } from "moment-range";
import { useSelector } from "react-redux";
import DeleteIcon from "@material-ui/icons/Delete";

import Checkbox from "@material-ui/core/Checkbox";
import ChallanDCDialog from "./ChallanDCDialog";
import { toast } from "react-toastify";
import { ConfirmationDialog } from "../../components/common";
import { challan4Template } from "../../assets/html/challan4Template";
import { calculateRunningBalance } from "../../utils/index.js";
import {
  applyAddressChoice,
  getAddressOptionsForAccount,
} from "../../utils/accountAddressPrint";

const moment = extendMoment(Moment);

const useStyles = makeStyles((theme) => ({
  fab: {
    position: "absolute",
    bottom: theme.spacing(-24),
    right: theme.spacing(2),
  },
  formControl: {
    paddingBottom: "10px",
    margin: "27px 0 0 0",
    position: "relative",
    verticalAlign: "unset",
  },
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
}));

let invoiceTemplates = [
  {
    label: "Thermal",
    value: "challan1",
  },
  {
    label: "Challan",
    value: "challan2",
  },
  {
    label: "A6",
    value: "challan3",
  },
  // {
  //   label: "TEST",
  //   value: "challan4",
  // },
];

const columns = [
  { id: "code", label: "Code" },
  {
    id: "amount",
    label: "Amount",
    format: (value) => formatINR0(value),
  },
  { id: "party", label: "Party", minWidth: 100 },
  { id: "isBilled", label: "Billed" },
  {
    id: "createdAt",
    label: "Created At",
    format: (value) => (value ? moment(value).format("DD-MM-YYYY") : ""),
  },
  { id: "action", label: "Action" },
  { id: "collapse" },
];
const itemColumns = [
  { id: "nameR", label: "Name R" },
  { id: "nameL", label: "Name L" },
  { id: "quantity", label: "Quantity" },
  {
    id: "amount",
    label: "Amount",
    format: (value) => formatINR0(value),
  },
];
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const MAX_ROWS_PER_PAGE = 100; // Maximum pagination limit for performance

/** One row in “Print multiple addresses” with optional shipping-address picker */
function MultipleAddressLabelRow({ accountData, entityDetails, addressLabelStyles }) {
  const [choice, setChoice] = useState("billing");
  const options = useMemo(() => getAddressOptionsForAccount(accountData), [accountData]);
  const display = useMemo(
    () => applyAddressChoice(accountData, choice),
    [accountData, choice]
  );

  useEffect(() => {
    setChoice("billing");
  }, [accountData?._id]);

  return (
    <div style={{ marginBottom: 16, paddingBottom: 12, borderBottom: "1px solid #eee" }}>
      {options.length > 1 ? (
        <FormControl fullWidth size="small" style={{ marginBottom: 8 }}>
          <InputLabel id={`addr-sel-${accountData?._id || "x"}`}>Address</InputLabel>
          <Select
            labelId={`addr-sel-${accountData?._id || "x"}`}
            value={choice}
            onChange={(e) => setChoice(e.target.value)}
          >
            {options.map((o) => (
              <MenuItem key={o.key} value={o.key}>
                {o.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : null}
      <div
        className="address-label"
        style={{
          ...addressLabelStyles.wrapper,
          marginBottom: 0,
        }}
      >
        <div style={addressLabelStyles.barcodeWrapper}>
          <p style={addressLabelStyles.text}>
            To, {display.name || display.accountName || ""}
          </p>
          <p style={addressLabelStyles.text}>
            {display.address || display.accountAddress || ""}
          </p>
          <p style={addressLabelStyles.text}>
            {display.city || ""}, {display.state || ""}
          </p>
          <p style={addressLabelStyles.text}>M: {display.mobile}</p>
          <p style={addressLabelStyles.text}>
            Pincode: {display.pin || display.pincode || ""}
          </p>
          {entityDetails && (entityDetails.name || entityDetails.address) && (
            <p style={addressLabelStyles.senderText}>
              From : {entityDetails.name || ""}, {entityDetails.address || ""}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export const ChallanList = React.memo((props) => {
  const classes = useStyles();
  const { searchTerm, filter, readyMasterRange } = props;
  console.log("rmr", searchTerm);
  const authToken = useSelector((state) => state.userReducer.authToken);
  const userInfo = useSelector((state) => state.userReducer.userInfo);
  console.log(userInfo, "my user info");

  const [challans, setChallans] = useState([]);
  const [openChallanAddDialog, setOpenChallanAddDialog] = useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [openAccountViewDialog, setOpenAccountViewDialog] = useState(null);
  const [openAccountAddressDialog, setOpenAccountAddressDialog] = useState(null);
  const [showInvoiceSelectionDialog, setShowInvoiceSelectionDialog] =
    useState(false);
  const [openViewDialog, setOpenViewDialog] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(null);
  const [sendWa, setSendWa] = useState(false);
  const [pdf, setPdf] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [openDCDialog, setOpenDCDialog] = useState(false);
  const [entityDetails, setEntityDetails] = useState({});
  const [accountCache, setAccountCache] = useState({});

  const [partyWithCashPreference, setPartyWithCashPreference] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [selectedChallan, setSelectedChallan] = useState(null);
  const [tota, setTota] = useState(0);
  const [calculatedChallanBalance, setCalculatedChallanBalance] = useState(0);
  console.log('calculatedChallanBalance208', calculatedChallanBalance);
  const [isCalculatingBalance, setIsCalculatingBalance] = useState(false);
  const [openImportDialog, setOpenImportDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [isExportingDailySales, setIsExportingDailySales] = useState(false);
  const [openMultipleAddressDialog, setOpenMultipleAddressDialog] = useState(false);
  const multipleAddressPrintRef = useRef();

  // Helper function to fetch account by ID with caching
  const fetchAccountById = async (accountId) => {
    if (!accountId) return null;

    // Check cache first
    if (accountCache[accountId]) {
      return accountCache[accountId];
    }

    // Fetch from API
    try {
      const res = await axios.get(GetAccountAPI(accountId), {
        headers: { Authorization: `Bearer ${authToken}` }
      });

      // Store in cache
      setAccountCache(prev => ({
        ...prev,
        [accountId]: res.data
      }));

      return res.data;
    } catch (e) {
      console.error("Error fetching account:", e);
      return null;
    }
  };

  const _getChallans = useMemo(
    () => async (page, rowsPerPage, signal) => {
      setLoading(true);
      console.log("limit & skip", rowsPerPage, page);

      if (
        rowsPerPage === undefined ||
        rowsPerPage === null ||
        rowsPerPage === NaN
      ) {
        rowsPerPage = 10;
      }

      if (page === undefined || page === null || page === NaN) {
        page = 0;
      }

      try {
        // Transaction history should show challans even after payment.
        // Do not filter by paymentStatus / isPaid / isBilled here.
        // Keep status=Active to avoid showing deleted/inactive challans.
        let query = `&limit=${rowsPerPage}&skip=${page * rowsPerPage}&status=${"Active"}`;
        let res = await axios.get(GetAllChallansAPI(userInfo.entity) + query, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
          signal: signal, // Add abort signal for request cancellation
        });

        setChallans(res.data.challans);
        setTota(res.data.total);
      } catch (err) {
        if (err.name === 'AbortError' || err.code === 'ECONNABORTED') {
          // Request was cancelled, ignore error
          return;
        }
        // Handle error
        toast.error("Error occured while fetching Transactions.");
      } finally {
        setLoading(false);
      }
    },
    [authToken, userInfo.entity] // Fix dependencies
  );

  const _getEntity = useMemo(
    () => async (signal) => {
      try {
        let res = await axios.get(GetEntityAPI(userInfo.entity), {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
          signal: signal, // Add abort signal for request cancellation
        });
        setEntityDetails(res.data);
      } catch (e) {
        if (e.name === 'AbortError' || e.code === 'ECONNABORTED') {
          // Request was cancelled, ignore error
          return;
        }
        // Handle error
        toast.error("Error occured while fetching enTITIES..");
      }
    },
    [authToken, userInfo.entity] // Fix dependencies
  );

  useEffect(() => {
    console.log("hello");
    const abortController = new AbortController();

    const fetchData = async () => {
      if (searchTerm != "") {
        console.log("no get");
      } else {
        await _getChallans(page, rowsPerPage, abortController.signal);
        await _getEntity(abortController.signal);
      }
    };

    fetchData();

    // Cleanup: cancel requests on unmount or dependency change
    return () => {
      abortController.abort();
    };
  }, [openAddDialog, openEditDialog, openDCDialog, page, rowsPerPage, searchTerm, _getChallans, _getEntity]);

  async function _deleteItem(item) {
  try {
      // Server now performs soft delete + side-effects behind this DELETE route
      await axios.delete(DeleteChallanAPI(item._id), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      toast.success("Successfully Deleted!", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      _getChallans();
      // window.location.reload();
    } catch (e) {
      console.log("err:", e);
      toast.error("Something went wrong, Please Contact Admin", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }

  // console.log(entityDetails.name)

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = Math.min(+event.target.value, MAX_ROWS_PER_PAGE);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  const handleOpenInvoiceSelectionModal = (item, wa = false) => {
    setSelectedItem(item);
    if (wa) {
      setSendWa(wa)
    }
    setShowInvoiceSelectionDialog(true);
  };

  function closeAccountViewDialog() {
    setOpenAccountViewDialog(null);
  }

  function closeAccountAddressDialog() {
    setOpenAccountAddressDialog(null);
  }

  function closeMultipleAddressDialog() {
    setOpenMultipleAddressDialog(false);
  }

  function handleOpenMultipleAddressDialog() {
    if (selectedRows.length === 0) {
      toast.warning("Please select at least one challan", {
        position: "top-center",
        autoClose: 2000,
      });
      return;
    }

    setOpenMultipleAddressDialog(true);
  }

  async function handleOpenAddressDialog(row) {
    // Fetch full account details from API with caching
    let accountData = null;
    if (row.party && row.party.accountId) {
      accountData = await fetchAccountById(row.party.accountId);
    }

    // Fallback to party data if account not found
    if (!accountData) {
      accountData = row.party || {};
    }

    // Pass full account from API when available so shippingAddress[] is available for print selection
    const account = accountData._id
      ? accountData
      : {
          name: accountData.name || accountData.accountName || "",
          accountName: accountData.accountName || accountData.name || "",
          address: accountData.address || accountData.accountAddress || "",
          accountAddress: accountData.accountAddress || accountData.address || "",
          city: accountData.city || accountData.accountCity || "",
          state: accountData.state || accountData.accountState || "",
          pin: accountData.pin || accountData.pincode || accountData.accountPin || "",
          pincode: accountData.pincode || accountData.pin || accountData.accountPin || "",
          mobile: accountData.mobile || accountData.accountMobile || "",
        };

    // Use entity details as sender
    const sender = {
      name: entityDetails.name || "",
      address: entityDetails.address || "",
    };

    setOpenAccountAddressDialog({
      open: true,
      account: account,
      sender: sender,
    });
  }

  function closeViewDialog() {
    setOpenViewDialog(null);
  }

  function closeEditDialog() {
    setOpenEditDialog(null);
  }

  function closeAddDialog() {
    setOpenAddDialog(false);
    _getChallans();
  }

  function closeDCDialog() {
    setOpenDCDialog(false);
  }
  // console.log(authToken, "auth")

  const showPrintModal = (item) => {
    setSelectedItem(item);
    setShowInvoiceSelectionDialog(true);
  };

  async function handleWhatsAppSend(pdfBlob) {
    try {
      console.log("selectedItem", selectedItem, "<<<<<<<<<<");
      if (!selectedItem || !pdfBlob) {
        toast.error("Missing required data for WhatsApp send");
        return;
      }
      if (!selectedItem?.party?.whatsappNumber) {
        toast.error("No Number found for WhatsApp send");
        return;
      }

      console.log(selectedItem, "selectedItem for WhatsApp send");

      const formData = new FormData();
      formData.append('file', pdfBlob, 'challan.pdf');
      formData.append('clientName', selectedItem.party?.accountName);
      formData.append('phone', selectedItem.party?.whatsappNumber);
      // formData.append('phone', );
      formData.append('challanCode', selectedItem.code);
      formData.append('challanDate', moment(selectedItem.createdAt).format("DD-MM-YYYY"));
      formData.append('challanAmount', selectedItem.amount);
      formData.append('challanStatus', selectedItem.status);
      formData.append('challanType', selectedItem.type);
      formData.append('template', "send_challan");
      formData.append('entityName', selectedItem.entity);

      const response = await axios.post(`${baseUrl}/send-whatsapp/ledgers`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${authToken}`
        }
      });

      if (response.data.success) {
        toast.success("Challan sent successfully on WhatsApp!");
        setSendWa(false); // Reset the state
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      console.error("WhatsApp send error:", error);
      toast.error(error.message || "Failed to send on WhatsApp");
    }
  }

  async function previewChallan(challan, invoiceType, qr, bank, wa, hideRate = false) {
    if (!challan) return;
    console.log(qr, challan, "qr<<<<350", bank, wa);
    let htmlData = {};
    /** API PATCH/POST often returns party as id or omit fields; list rows embed full party. */
    const rawParty = challan.party;
    const accountIdForPrint =
      typeof rawParty === "string"
        ? rawParty
        : rawParty?.accountId || rawParty?._id;
    let party =
      typeof rawParty === "object" && rawParty !== null ? rawParty : {};
    let challanCode = challan.code;
    let packagingCost = challan.packagingCost;
    let items = [],
      totalQuantity = 0;

    let challanCreatedAtDate = challan.createdAt;

    _.map(challan.items, async (item, index) => {
      let {
        codeL,
        codeR,
        nameL,
        nameR,
        rateR,
        rateL,
        quantity,
        amount,
        fitting,
        fittingAmount,
        discountAmount,
        discountPercent,
        tint,
      } = item;
      let productName = "",
        price = 0;

      // Discount is already applied to rateR/rateL (discounted price), so don't show discount again in printed challan
      items.push({
        name: productName,
        rate: amount,
        codeR,
        codeL,
        nameL,
        nameR,
        rateR,
        rateL,
        fitting,
        fittingAmount,
        quantity,
        discountAmount: "", // Remove discount from printed challan since it's already applied to rate
        discountPercent: "", // Remove discount from printed challan since it's already applied to rate
        tint,
      });
    });

    let res = await axios.get(GetAllPrintAdsAPI(userInfo.entity));
    let printAds = res.data.printAds;

    let ad = "";
    if (printAds && printAds.length > 0) {
      // Sort by createdAt (newest first) and get only the latest one
      const sortedPrintAds = [...printAds].sort((a, b) => {
        const dateA = new Date(a.createdAt || a._id || 0);
        const dateB = new Date(b.createdAt || b._id || 0);
        return dateB - dateA; // Descending order (newest first)
      });

      // Get only the latest (first) print ad
      const latestAd = sortedPrintAds[0];
      if (latestAd && latestAd.title) {
        ad = latestAd.title;
      }
    }

    // Fetch account details with caching (works when party is only an id on save-and-print response)
    let accountRes = await fetchAccountById(accountIdForPrint);

    // Calculate running balance using global function and use the returned value
    let runningChallanBalance = null;
    if (accountRes?.showRunningBalance) {
      console.log('accountRes onPreview 1', accountRes);
      runningChallanBalance = await _calculateRunningBalance(accountRes);
      console.log('runningChallanBalance (direct)', runningChallanBalance);
    }

    // Only include QR code if both qr is true AND bank with qrCode exists
    const shouldIncludeQR = qr && bank && bank.qrCode && typeof bank.qrCode === 'string' && bank.qrCode.trim() !== '';
    // Use qrCode as-is (it should already be in the correct format from the database)
    const qrCodePath = shouldIncludeQR ? bank.qrCode.trim() : null;

    console.log('QR Code Debug:', {
      qr,
      bank: bank ? { name: bank.bankName, qrCode: bank.qrCode } : null,
      shouldIncludeQR,
      qrCodePath,
      fullUrl: qrCodePath ? `${baseUrl}${qrCodePath}` : null
    });

    const clientName =
      party.accountName || party.name || accountRes?.accountName || "";
    const clientAddress =
      party.accountAddress ||
      party.address ||
      accountRes?.accountAddress ||
      "";
    const clientGSTNo = party.gst ?? accountRes?.gst ?? "";

    htmlData = {
      qrCode: qrCodePath,
      qr: shouldIncludeQR, // Only set to true if we actually have a QR code
      ad,
      clientAddress,
      clientName,
      clientGSTNo,
      challanDate: moment().format("DD-MM-YYYY"),
      createdAt: moment(challanCreatedAtDate).format("DD-MM-YYYY"),
      items: challan.items,
      quantity: totalQuantity,
      challanCode,
      packagingCost: challan.packagingCost,
      entityName: entityDetails.name,
      entityId: entityDetails._id,
      hideRate: hideRate || false,
      ...(accountRes?.showRunningBalance && {
        runningChallanBalance: _.round(runningChallanBalance, 2)
      }),
    };

    console.log(htmlData, "my data487");
    let options = null;
    if (invoiceType === "challan1") {
      // Always use server thermal PDF so single print matches bulk thermal output.
      try {
        const res = await axios.post(
          GenerateChallanThermalMultiPDFAPI(),
          {
            challanIds: [challan?._id],
            entity: userInfo.entity,
            percent: 0,
            hideRate: Boolean(hideRate),
            // Optional extras (backend may ignore)
            qr: Boolean(shouldIncludeQR),
            qrCode: qrCodePath,
          },
          {
            headers: { Authorization: `Bearer ${authToken}` },
            responseType: "blob",
          }
        );

        const serverBlob = new Blob([res.data], { type: "application/pdf" });
        const serverUrl = URL.createObjectURL(serverBlob);
        setPdf({ blob: serverBlob, url: serverUrl });
        window.open(serverUrl);
        if (wa) {
          await handleWhatsAppSend(serverBlob);
        }
      } catch (e) {
        console.error("Thermal print failed (server):", e);
        const msg =
          e?.response?.data?.message ||
          e?.response?.data?.error ||
          e?.message ||
          "Please try again.";
        toast.error(`Thermal print failed. ${msg}`, {
          position: "top-center",
          autoClose: 3500,
        });
      }
    } else if (invoiceType === "challan2") {
      // challan2Template now returns a Promise<Blob>
      const pdfBlob = await challan2Template(htmlData);
      const pdfUrl = URL.createObjectURL(pdfBlob);
      setPdf({ blob: pdfBlob, url: pdfUrl });
      window.open(pdfUrl);
      if (wa) {
        await handleWhatsAppSend(pdfBlob);
      }
    } else if (invoiceType === "challan3") {
      // challan3Template now returns a Promise<Blob>
      const pdfBlob = await challan3Template(htmlData);
      const pdfUrl = URL.createObjectURL(pdfBlob);
      setPdf({ blob: pdfBlob, url: pdfUrl });
      window.open(pdfUrl);
      if (wa) {
        await handleWhatsAppSend(pdfBlob);
      }
    }
    // else if (invoiceType === "challan4") {
    //   options = {
    //     orientation: "p",
    //     unit: "px",
    //     hotfixes: true,
    //     format: "a4",
    //     // format: [850, 1066],
    //     // format:'letter',
    //     putOnlyUsedFonts: true,
    //   };
    //   htmlTemplate = challan4Template(htmlData);
    // }
    // htmlTemplate is no longer used (we generate/open blobs directly)

    // await htmlTemplateToDataString(htmlTemplate, options, async (dataString) => {
    //   console.log("DSTRING", dataString);
    //   const pdfBlob = dataURItoBlob(dataString);
    //   const pdfUrl = URL.createObjectURL(pdfBlob);
    //   // Store both blob and URL
    //   setPdf({
    //     blob: pdfBlob,
    //     url: pdfUrl
    //   });
    //   window.open(pdfUrl);
    //   // If this is a WhatsApp share, trigger the send
    //   if (wa) {
    //     await handleWhatsAppSend(pdfBlob);
    //   }
    // });
  }

  async function _onPreview(invoiceType, qr, bank, wa, hideRate = false) {
    if (_.isEmpty(selectedItem)) return;
    return previewChallan(selectedItem, invoiceType, qr, bank, wa, hideRate);
  }

  // useEffect(async() => {
  //   console.log("running wa effect")
  //   if (sendWa && pdf) {
  //   console.log("sendWa", sendWa, pdf, selectedItem, "selectedItem")
  //     try {
  //     console.log("Sending WhatsApp message with PDF blob:", pdf);
  //     const formData = new FormData();
  //     formData.append('file', pdf);
  //     formData.append('phone', selectedItem.whatsappNumber || selectedItem.mobile);
  //     formData.append(
  //       'message',
  //       `Challan`
  //     );

  //     const response = await axios.post('http://localhost:3000/send-whatsapp/ledgers', formData, {
  //       headers: {
  //         'Content-Type': 'multipart/form-data',
  //         Authorization: `Bearer ${authToken}`,
  //       },
  //     });

  //     if (response.data.success) {
  //       toast.success("Ledger sent successfully on WhatsApp!");
  //       return true;
  //     } else {
  //       throw new Error(response.data.message || "Failed to send WhatsApp message");
  //     }
  //   } catch (error) {
  //     //console.error("WhatsApp send error:", error);
  //     toast.error(error.response?.data?.message || error.message || "Failed to send ledger on WhatsApp");
  //     return false;
  //   }
  //   }
  // }, [sendWa, pdf])


  const InvoiceSelectionDialog = () => {
    const [includeQRCode, setIncludeQRCode] = useState(false);
    const [banks, setBanks] = useState([])
    const [selectedBankId, setSelectedBankId] = useState(null);
    const [hideRate, setHideRate] = useState(false);

    console.log(banks, "banaks")


    useEffect(() => {
      // Only fetch banks when dialog is actually open
      if (userInfo?.entity && showInvoiceSelectionDialog) {
        _getBanks();
      }
    }, [userInfo?.entity, showInvoiceSelectionDialog]); // ✅ Only re-run when entity or dialog open state changes

    // Auto-select first bank with QR code when banks are loaded and QR code is enabled
    useEffect(() => {
      if (banks.length > 0 && includeQRCode && !selectedBankId) {
        // Find first bank that has a QR code
        const bankWithQR = banks.find(bank => bank.qrCode && bank.qrCode.trim() !== "");
        if (bankWithQR) {
          setSelectedBankId(bankWithQR._id);
        } else if (banks.length > 0) {
          // If no bank has QR code, show warning
          toast.warning("No banks with QR codes available. Please add QR codes to banks.", {
            position: "top-center",
            autoClose: 3000,
          });
        }
      }
    }, [banks, includeQRCode, selectedBankId]);

    async function _getBanks() {
      try {
        let res = await axios.get(GetAllBanksAPI(userInfo.entity));
        const fetchedBanks = res.data.banks || [];
        setBanks(fetchedBanks);
      } catch (e) {
        console.log("er:", e);
      }
    }

    const selectedBank = (banks || []).find((bank) => bank._id === selectedBankId);

    const handleQRCodeToggle = (checked) => {
      setIncludeQRCode(checked);
      if (checked) {
        // Auto-select first bank with QR code when QR code is enabled
        const bankWithQR = banks.find(bank => bank.qrCode && bank.qrCode.trim() !== "");
        if (bankWithQR && !selectedBankId) {
          setSelectedBankId(bankWithQR._id);
        } else if (!bankWithQR && banks.length > 0) {
          toast.warning("No banks with QR codes available. Please add QR codes to banks.", {
            position: "top-center",
            autoClose: 3000,
          });
        }
      } else {
        // Clear selection when QR code is disabled
        setSelectedBankId(null);
      }
    };

    const handlePrint = (invoiceType) => {
      // Validate: if QR code is checked, bank must be selected
      if (includeQRCode && !selectedBank) {
        toast.error("Please select a bank for QR code", {
          position: "top-center",
          autoClose: 2000,
        });
        return;
      }

      // Additional validation: if QR code is checked, ensure bank has QR code
      if (includeQRCode && selectedBank && !selectedBank.qrCode) {
        toast.error("Selected bank does not have a QR code", {
          position: "top-center",
          autoClose: 2000,
        });
        return;
      }

      console.log('_onPreview', invoiceType, includeQRCode, selectedBank, sendWa, hideRate, "<<<<sendWa");
      _onPreview(invoiceType, includeQRCode, selectedBank, sendWa, hideRate);
      setShowInvoiceSelectionDialog(false);
    };

    return (
      <Dialog
        onClose={() => setShowInvoiceSelectionDialog(false)}
        aria-labelledby="simple-dialog-title"
        open={showInvoiceSelectionDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="simple-dialog-title">Print Challan</DialogTitle>
        <DialogContent>
          <List>
            {/* QR Code Checkbox - First Option */}
            <Box style={{
              padding: "12px",
              backgroundColor: includeQRCode ? "#e3f2fd" : "transparent",
              borderRadius: "4px",
              border: includeQRCode ? "1px solid #1976d2" : "1px solid #e0e0e0",
              marginBottom: "16px"
            }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={includeQRCode}
                    onChange={(e) => handleQRCodeToggle(e.target.checked)}
                    color="primary"
                  />
                }
                label={
                  <Box>
                    <Box style={{ fontWeight: "bold", marginBottom: "4px" }}>
                      Include QR Code on PDF
                    </Box>
                    {includeQRCode && selectedBank && (
                      <Box style={{ fontSize: "12px", color: "#1976d2", marginTop: "4px" }}>
                        ✓ Selected: {selectedBank.bankName}
                      </Box>
                    )}
                    {includeQRCode && !selectedBank && banks.length > 0 && (
                      <Box style={{ fontSize: "12px", color: "#f44336", marginTop: "4px" }}>
                        ⚠ Please select a bank below
                      </Box>
                    )}
                  </Box>
                }
              />
            </Box>

            {/* Bank QR Code Selection - Only show when QR code is enabled */}
            {includeQRCode && (
              <Box style={{ marginBottom: "16px" }}>
                <DialogTitle style={{ padding: "8px 0", fontSize: "16px", fontWeight: "bold" }}>
                  Select Bank (QR Code) {selectedBank && <span style={{ color: "#4caf50" }}>✓</span>}
                </DialogTitle>
                {banks.length === 0 ? (
                  <ListItem>
                    <ListItemText
                      primary="No banks available"
                      secondary="Please add banks in settings"
                      style={{ color: "#999" }}
                    />
                  </ListItem>
                ) : (
                  banks.map((bank) => {
                    const hasQRCode = bank.qrCode && bank.qrCode.trim() !== "";
                    return (
                      <ListItem
                        button
                        key={bank._id}
                        selected={bank._id === selectedBankId}
                        onClick={() => {
                          if (hasQRCode) {
                            setSelectedBankId(bank._id);
                          } else {
                            toast.warning("This bank does not have a QR code", {
                              position: "top-center",
                              autoClose: 2000,
                            });
                          }
                        }}
                        disabled={!hasQRCode}
                        style={{
                          border: bank._id === selectedBankId
                            ? "2px solid #1976d2"
                            : hasQRCode
                              ? "1px solid #e0e0e0"
                              : "1px solid #ffcdd2",
                          marginBottom: "8px",
                          borderRadius: "4px",
                          opacity: hasQRCode ? 1 : 0.6,
                          backgroundColor: bank._id === selectedBankId ? "#e3f2fd" : "transparent"
                        }}
                      >
                        <Radio
                          checked={bank._id === selectedBankId}
                          disabled={!hasQRCode}
                        />
                        <ListItemAvatar>
                          {hasQRCode ? (
                            <Avatar
                              variant="square"
                              src={`${baseUrl}${bank.qrCode}`}
                              alt={`${bank.bankName} QR`}
                              style={{ width: 56, height: 56, marginRight: 8 }}
                              onError={(e) => {
                                e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='56' height='56'%3E%3Crect width='56' height='56' fill='%23f5f5f5'/%3E%3Ctext x='50%25' y='50%25' text-anchor='middle' dy='.3em' fill='%23999' font-size='10'%3ENo QR%3C/text%3E%3C/svg%3E";
                              }}
                            />
                          ) : (
                            <Avatar
                              variant="square"
                              style={{
                                width: 56,
                                height: 56,
                                marginRight: 8,
                                backgroundColor: "#ffcdd2",
                                color: "#c62828"
                              }}
                            >
                              No QR
                            </Avatar>
                          )}
                        </ListItemAvatar>
                        <ListItemText
                          primary={
                            <Box style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <span>{bank.bankName}</span>
                              {bank._id === selectedBankId && (
                                <span style={{ color: "#4caf50", fontSize: "14px" }}>✓ Selected</span>
                              )}
                              {!hasQRCode && (
                                <span style={{ color: "#f44336", fontSize: "12px" }}>(No QR Code)</span>
                              )}
                            </Box>
                          }
                          secondary={`IFSC: ${bank.ifscCode || 'N/A'} | Branch: ${bank.branch || 'N/A'}`}
                        />
                      </ListItem>
                    );
                  })
                )}
              </Box>
            )}

            {/* Print Without Rate Option */}
            <Box style={{
              padding: "12px",
              backgroundColor: hideRate ? "#e3f2fd" : "transparent",
              borderRadius: "4px",
              border: hideRate ? "1px solid #1976d2" : "1px solid #e0e0e0",
              marginTop: "16px",
              marginBottom: "16px"
            }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={hideRate}
                    onChange={(e) => setHideRate(e.target.checked)}
                    color="primary"
                  />
                }
                label="Print Without Rate (Hide all rate-related information)"
              />
            </Box>

            {/* Divider */}
            {includeQRCode && (
              <Box style={{ marginTop: "16px", marginBottom: "16px", borderTop: "1px solid #e0e0e0" }} />
            )}

            {/* Invoice Template Options */}
            <Box style={{ marginTop: includeQRCode ? "0" : "16px", marginBottom: "16px" }}>
              <DialogTitle style={{ padding: "8px 0", fontSize: "16px", fontWeight: "bold" }}>
                Select Template
              </DialogTitle>
              {invoiceTemplates.map(({ label, value }) => (
                <ListItem
                  button
                  onClick={() => handlePrint(value)}
                  key={value}
                  style={{ border: "1px solid #e0e0e0", marginBottom: "8px", borderRadius: "4px" }}
                >
                  <ListItemText primary={label} />
                </ListItem>
              ))}
            </Box>
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowInvoiceSelectionDialog(false)} color="secondary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const MultipleAddressDialog = () => {
    const [addressLabels, setAddressLabels] = useState([]);
    const [loadingAddresses, setLoadingAddresses] = useState(false);

    // Fetch address labels when dialog opens or selected rows change
    useEffect(() => {
      const fetchAddressLabels = async () => {
        if (!openMultipleAddressDialog) return;

        setLoadingAddresses(true);
        try {
          // Get selected challans
          const selectedChallans = data.filter((challan) =>
            selectedRows.includes(challan._id)
          );

          // Fetch all account details in parallel
          const labels = await Promise.all(
            selectedChallans
              .filter((challan) => challan.party) // Only filter out if no party exists
              .map(async (challan) => {
                let accountData = null;
                if (challan.party.accountId) {
                  accountData = await fetchAccountById(challan.party.accountId);
                }

                if (!accountData) {
                  accountData = challan.party || {};
                }

                return {
                  accountData: accountData._id
                    ? accountData
                    : {
                        name: accountData.accountName || accountData.name || "",
                        accountName: accountData.accountName || accountData.name || "",
                        address: accountData.address || accountData.accountAddress || "",
                        accountAddress:
                          accountData.accountAddress || accountData.address || "",
                        city: accountData.city || accountData.accountCity || "",
                        state: accountData.state || accountData.accountState || "",
                        pin:
                          accountData.pin ||
                          accountData.pincode ||
                          accountData.accountPin ||
                          "",
                        pincode:
                          accountData.pincode ||
                          accountData.pin ||
                          accountData.accountPin ||
                          "",
                        mobile: accountData.mobile || accountData.accountMobile || "",
                      },
                };
              })
          );

          setAddressLabels(labels);
        } catch (error) {
          console.error("Error fetching address labels:", error);
          toast.error("Failed to load address labels");
        } finally {
          setLoadingAddresses(false);
        }
      };

      fetchAddressLabels();
    }, [openMultipleAddressDialog, selectedRows]);

    const handlePrint = useReactToPrint({
      content: () => multipleAddressPrintRef.current,
      documentTitle: "",
      pageStyle: ` 
    @media print {  
        @page {
            size: 333px 200px;
            margin: 0mm;
            padding: 0mm;
        }
        .address-label {
            width: 376px;
            height: 188px;
            page-break-after: always;
            page-break-inside: avoid;
        }
        .address-label:last-child {
            page-break-after: auto;
        }
    }`,
    });

    // Match the exact styles from AccountAddress component
    const addressLabelStyles = {
      wrapper: {
        width: 376,
        height: 188,
      },
      barcodeWrapper: {
        marginTop: "5px",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        flexDirection: "column",
      },
      text: {
        fontSize: "18px",
        fontWeight: "700",
        margin: 0,
      },
      senderText: {
        fontSize: "18px",
        margin: 0,
      },
    };

    return (
      <Dialog
        open={openMultipleAddressDialog}
        onClose={closeMultipleAddressDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Print Multiple Address Labels</DialogTitle>
        <DialogContent>
          {loadingAddresses ? (
            <Box display="flex" justifyContent="center" alignItems="center" padding="40px">
              <CircularProgress />
              <Box marginLeft="16px">Loading address labels...</Box>
            </Box>
          ) : (
            <Box ref={multipleAddressPrintRef} style={{ padding: "14px" }}>
              {addressLabels.map((row, index) => (
                <MultipleAddressLabelRow
                  key={row.accountData?._id || index}
                  accountData={row.accountData}
                  entityDetails={entityDetails}
                  addressLabelStyles={addressLabelStyles}
                />
              ))}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeMultipleAddressDialog} color="secondary">
            Close
          </Button>
          <Button color="primary" onClick={handlePrint}>
            Print All Addresses
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const RenderTableRow = (props) => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    let { row } = props;
    if (!row) {
      return null;
    }
    let { orderId, orderNo, challanId, orderDate, party, items } = row;
    return (
      <>
        <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
          <TableCell padding="checkbox">
            <Checkbox
              style={{
                color: "#512da8",
              }}
              onChange={() => {
                let copy = _.clone(selectedRows);
                if (_.includes(copy, row._id)) {
                  let index = _.indexOf(copy, row._id);
                  copy.splice(index, 1);
                } else {
                  copy.push(row._id);
                }
                setSelectedRows(copy);
              }}
              checked={_.includes(selectedRows, row._id)}
              inputProps={{ "aria-labelledby": row._id }}
            />
          </TableCell>
          {columns.map((column) => {
            let value = row[column.id];
            if (column.id === "party") {
              value = value ? value.accountName : "";
            }
            if (column.id === "collapse") {
              return (
                <TableCell align={"center"}>
                  <IconButton
                    aria-label="expand row"
                    size="small"
                    onClick={() => setIsCollapsed(!isCollapsed)}
                  >
                    {isCollapsed ? (
                      <KeyboardArrowUpIcon />
                    ) : (
                      <KeyboardArrowDownIcon />
                    )}
                  </IconButton>
                </TableCell>
              );
            }
            if (column.id === "createdAt") {
              return (
                <TableCell>{moment(value).format("DD-MM-YYYY")}</TableCell>
              );
            }
            if (column.id === "amount") {
              return (
                <TableCell>
                  {Number(value).toLocaleString("en-IN", {
                    maximumFractionDigits: 2,
                    style: "currency",
                    currency: "INR",
                  })}
                </TableCell>
              );
            }
            if (column.id === "isBilled") {
              return <TableCell>{value ? "Yes" : "No"}</TableCell>;
            }
            if (column.id === "action") {
              return (
                <TableCell align={"center"}>
                  <Box display={"flex"} justifyContent={"center"}>
                    <IconButton
                      onClick={() =>
                        setOpenEditDialog({
                          open: true,
                          item: row,
                        })
                      }
                      aria-label="view"
                    >
                      <EditIcon />
                    </IconButton>
                    <IconButton
                      onClick={() => handleOpenInvoiceSelectionModal(row, false)}
                      aria-label="print"
                      title="Print Challan"
                    >
                      <Receipt />
                    </IconButton>
                    <IconButton
                      onClick={() => handleOpenAddressDialog(row)}
                      aria-label="print-address"
                      title="Print Address Label"
                    >
                      <LocalShippingIcon />
                    </IconButton>
                    <IconButton
                      onClick={() => {
                        setOpenConfirmationDialog(true);
                        setSelectedChallan(row);
                      }}
                      aria-label="delete"
                    >
                      <DeleteIcon />
                    </IconButton>
                    <IconButton
                      aria-label="view"
                      onClick={() =>
                        setOpenViewDialog({
                          open: true,
                          item: row,
                        })
                      }
                    >
                      <VisibilityIcon />
                    </IconButton>
                    <IconButton
                      aria-label="whatsapp"
                      onClick={() => handleOpenInvoiceSelectionModal(row, true)}
                    >
                      <WhatsAppIcon />
                    </IconButton>
                  </Box>
                </TableCell>
              );
            }
            return (
              <TableCell
                key={column.id}
                align={column.align}
                onClick={async () => {
                  if (column.id === "party") {
                    try {
                      // let oneAccount = _.find(accounts, { _id: row._id });
                      // let res = await axios.get(GetAccountAPI(row._id), {
                      //   headers: {
                      //     Authorization: `Bearer ${authToken}`,
                      //   },
                      // });
                      // console.log("q acc", oneAccount)
                      // setOpenAccountViewDialog({
                      //   open: true,
                      //   item: oneAccount,
                      // });
                    } catch (e) {
                      // console.log("err:", e);
                      toast.error(
                        "Something went wrong, Please Contact Admin",
                        {
                          position: "top-center",
                          autoClose: 1500,
                          hideProgressBar: false,
                          closeOnClick: true,
                          pauseOnHover: true,
                          draggable: true,
                          progress: undefined,
                          theme: "light",
                        }
                      );
                    }
                  }
                }}
              >
                {column.format && typeof value === "number"
                  ? column.format(value)
                  : value}
              </TableCell>
            );
          })}
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
            <Collapse in={isCollapsed} timeout="auto" unmountOnExit>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    {itemColumns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={"center"}
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items.map((row, index) => {
                    return (
                      <TableRow key={index} hover role="checkbox" tabIndex={-1}>
                        {itemColumns.map((column) => {
                          let value = row[column.id];
                          if (column.id === "nameL") {
                            value = row.nameL + " " + row.codeL;
                          } else if (column.id === "nameR") {
                            value = row.nameR + " " + row.codeR;
                          }
                          return (
                            <TableCell key={column.id} align={"center"}>
                              {value}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Collapse>
          </TableCell>
        </TableRow>
      </>
    );
  };

  async function searchChallan(searchTerm) {
    setLoading(true);
    try {
      let query = `&search=${searchTerm}&limit=${rowsPerPage}&skip=${page * rowsPerPage
        }&status=${"Active"}`;
      let challa = await axios.get(GetAllChallansAPI(userInfo.entity) + query, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      console.log("search challan", challa.data.challans.length);
      setChallans(challa.data.challans);
      setTota(challa.data.total);
      // Process the result of the API call
    } catch (error) {
      console.error("Error fetching data from API:", error);
    } finally {
      setLoading(false);
    }
  }
  let data = challans;

  useEffect(() => {
    if (searchTerm !== "") {
      searchChallan(searchTerm);
    }
    // } else {
    //   _getChallans();
    // }
  }, [searchTerm, page, rowsPerPage]);

  // async function searchChallan(searchTerm) {
  //   try {
  //     let query = `&search=${searchTerm}`;
  //     let challa = await axios.get(GetAllChallansAPI(userInfo.entity) + query, {
  //       headers: {
  //         Authorization: `Bearer ${authToken}`,
  //       },
  //     });

  //     console.log('search challan', challa)
  //     // setChallans(challa);
  //     // Process the result of the API call
  //   } catch (error) {
  //     console.error("Error fetching data from API:", error);
  //   }
  // }

  // let data = challans;

  // if (searchTerm !== "") {

  //   searchChallan(searchTerm);

  //   // data = _.filter(data, (i) => {
  //   //   return i.code && i.code.toLowerCase().includes(searchTerm.toLowerCase());
  //   // });
  //   // console.log("filter k vbaad", data);
  //   if (data.length === 0) {

  //     _getChallans();

  //     // searchChallan(searchTerm);
  //   }
  // }

  if (filter) {
    let { startDate, endDate, party, status } = filter;
    if (startDate && endDate) {
      data = _.filter(data, (i) => {
        return (
          moment(startDate).isSame(moment.utc(i.createdAt), "day") ||
          moment(i.createdAt).isBetween(
            moment.utc(startDate),
            moment.utc(endDate),
            "day"
          ) ||
          moment(endDate).isSame(moment.utc(i.createdAt), "day")
        );
      });
    }
    if (party) {
      data = _.filter(data, (i) => {
        return i.party.accountName === party;
      });
    }
    if (status) {
      data = _.filter(data, (i) => {
        return i.paymentStatus === status;
      });
    }
  }

  // Function to calculate running balance for challan activity
  // This uses the global calculateRunningBalance function from utils/index.js
  // with activityType set to "sale" to filter only sale transactions (challan activity)
  // This ensures we only see running balances related to challan/sale activities
  async function _calculateRunningBalance(selectedParty) {
    console.log('selectedParty988', selectedParty);
    setIsCalculatingBalance(true);
    try {
      // Calculate Challan running balance for challan activity
      const challanBalance = await calculateRunningBalance(
        selectedParty,
        "Challan",
        userInfo,
        authToken,
        GetAllLedgersAPI,
        null, // transactionType (null for all)
        "sale" // activityType - specifically for sale (challan activity)
      );
      console.log('challanBalance998', challanBalance);
      setCalculatedChallanBalance(challanBalance);
      return challanBalance; // <-- return the value
    } catch (error) {
      console.error('Error calculating running balance:', error);
      // Fallback to existing value
      setCalculatedChallanBalance(0);
      return 0;
    } finally {
      setIsCalculatingBalance(false);
    }
  }

  // Prepare export data
  const exportData = data.map((challan) => ({
    code: challan.code,
    amount: challan.amount,
    party: challan.party?.accountName || '',
    partyCode: challan.party?.accountCode || '',
    partyAddress: challan.party?.accountAddress || '',
    partyGst: challan.party?.accountGst || '',
    packagingCost: challan.packagingCost || 0,
    createdAt: moment(challan.createdAt).format("DD-MM-YYYY"),
    status: challan.status,
    paymentStatus: challan.paymentStatus,
    isBilled: challan.isBilled ? 'Yes' : 'No',
    // Items as JSON string for complex data
    items: JSON.stringify(challan.items || [])
  }));

  // Export current challan data to Excel using XLSX
  const handleExport = () => {
    if (!data || data.length === 0) {
      toast.error("No challans to export!", {
        position: "top-center",
        autoClose: 2000,
      });
      return;
    }

    setIsExporting(true);
    try {
      const worksheetData = data.map((challan) => ({
        Code: challan.code,
        Amount: challan.amount,
        Party: challan.party?.accountName || "",
        "Party Code": challan.party?.accountCode || "",
        "Party Address": challan.party?.accountAddress || "",
        "Party GST": challan.party?.accountGst || "",
        "Packaging Cost": challan.packagingCost || 0,
        "Created At": moment(challan.createdAt).format("DD-MM-YYYY"),
        Status: challan.status,
        "Payment Status": challan.paymentStatus,
        "Is Billed": challan.isBilled ? "Yes" : "No",
        Items: JSON.stringify(challan.items || []),
      }));

      const worksheet = XLSX.utils.json_to_sheet(worksheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Challans");
      XLSX.writeFile(workbook, "challans_export.xlsx");

      toast.success(`Successfully exported ${worksheetData.length} records to Excel!`, {
        position: "top-center",
        autoClose: 2000,
      });
    } catch (error) {
      console.error("Challan export error:", error);
      toast.error(
        error.response?.data?.message ||
        "Failed to export challans. Please try again.",
        {
          position: "top-center",
          autoClose: 3000,
        }
      );
    } finally {
      setIsExporting(false);
    }
  };

  // Download an empty import template for challans
  const handleExportTemplate = () => {
    try {
      const headerRow = ["party", "amount", "packagingCost", "createdAt", "items"];
      const worksheet = XLSX.utils.aoa_to_sheet([headerRow]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Import Template");
      XLSX.writeFile(workbook, "challans_import_template.xlsx");
    } catch (error) {
      console.error("Challan template export error:", error);
      toast.error(
        error.response?.data?.message ||
        "Failed to download import template. Please try again.",
        {
          position: "top-center",
          autoClose: 3000,
        }
      );
    }
  };

  // Export daily sales (challans from today) to Excel
  const handleExportDailySales = async () => {
    setIsExporting(true);
    setIsExportingDailySales(true);
    try {
      const todayFormatted = moment().format("DD-MM-YYYY");

      // Use server-side date filtering instead of fetching all records
      let query = `&status=Active&startDate=${todayFormatted}&endDate=${todayFormatted}&skip=0&limit=10000`;
      let res = await axios.get(GetAllChallansAPI(userInfo.entity) + query, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      // Always start/end date = current date, but apply the remaining UI filters (party, paymentStatus)
      // exactly like the table does.
      let todayChallans = res.data.challans || [];

      if (filter) {
        const { party, status } = filter || {};
        if (party) {
          todayChallans = _.filter(todayChallans, (i) => i?.party?.accountName === party);
        }
        if (status) {
          todayChallans = _.filter(todayChallans, (i) => i?.paymentStatus === status);
        }
      }

      if (todayChallans.length === 0) {
        toast.warning("No challans found for today!", {
          position: "top-center",
          autoClose: 2000,
        });
        return;
      }

      const worksheetData = todayChallans.map((challan) => {
        try {
          return {
            Code: String(challan.code || ""),
            Amount: Number(challan.amount) || 0,
            Party: String(challan.party?.accountName || ""),
            "Party Code": String(challan.party?.accountCode || ""),
            "Party Address": String(challan.party?.accountAddress || ""),
            "Party GST": String(challan.party?.accountGst || ""),
            "Packaging Cost": Number(challan.packagingCost) || 0,
            "Created At": challan.createdAt ? moment(challan.createdAt).format("DD-MM-YYYY") : "",
            Status: String(challan.status || ""),
            "Payment Status": String(challan.paymentStatus || ""),
            "Is Billed": challan.isBilled ? "Yes" : "No",
            Items: challan.items && Array.isArray(challan.items) ? challan.items.length : 0,
          };
        } catch (e) {
          console.error("Error mapping challan data:", e);
          return {};
        }
      });

      const worksheet = XLSX.utils.json_to_sheet(worksheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Daily Sales");
      XLSX.writeFile(workbook, `daily_sales_${todayFormatted}.xlsx`);

      toast.success(`Successfully exported ${worksheetData.length} daily sales records to Excel!`, {
        position: "top-center",
        autoClose: 2000,
      });
    } catch (error) {
      console.error("Daily sales export error:", error);
      toast.error(
        error.response?.data?.message ||
        "Failed to export daily sales. Please try again.",
        {
          position: "top-center",
          autoClose: 3000,
        }
      );
    } finally {
      setIsExporting(false);
      setIsExportingDailySales(false);
    }
  };

  return (
    <>
      <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
        <Box display={"flex"} alignItems={"center"}>
          <Tooltip title={isExportingDailySales ? "Exporting Daily Sales..." : "Export Daily Sales (Today's challans)"}>
            <IconButton
              color={"primary"}
              onClick={handleExportDailySales}
              disabled={isExporting || isExportingDailySales}
            >
              {isExportingDailySales ? <CircularProgress size={22} /> : <CloudDownload />}
            </IconButton>
          </Tooltip>
          <Tooltip title={"Export to excel"}>
            <IconButton
              color={"primary"}
              onClick={handleExport}
              disabled={isExporting}
            >
              <CloudDownload />
            </IconButton>
          </Tooltip>
          <Tooltip title={"Import Template"}>
            <IconButton
              color={"primary"}
              onClick={handleExportTemplate}
              disabled={isExporting}
            >
              <CloudUpload />
            </IconButton>
          </Tooltip>
          <Tooltip title={"Import Excel to database"}>
            <IconButton
              color={"primary"}
              onClick={() => setOpenImportDialog(true)}
            >
              <CloudUpload />
            </IconButton>
          </Tooltip>
        </Box>
        <Box display={"flex"} alignItems={"center"}>
          <IconButton aria-label="add" onClick={() => setOpenAddDialog(true)}>
            <AddIcon />
          </IconButton>
          {selectedRows.length > 0 && (
            <IconButton
              aria-label="add"
              onClick={() => setOpenDCDialog(true)}
            >
              <PrintIcon />
            </IconButton>
          )}
          {selectedRows.length > 1 && (
            <Tooltip title="Print Multiple Address Labels">
              <IconButton
                aria-label="print-multiple-addresses"
                onClick={handleOpenMultipleAddressDialog}
              >
                <LocalShippingIcon />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      </Box>
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            <Checkbox
              style={{
                color: "#512da8",
              }}
              onChange={(e) => {
                let c = [];
                if (e.target.checked) {
                  data.map((i) => {
                    c.push(i._id);
                  });
                }
                setSelectedRows(c);
              }}
              checked={
                selectedRows.length > 0 && data.length === selectedRows.length
              }
              inputProps={{ "aria-labelledby": -1 }}
            />
            {columns.map((column) => (
              <TableCell
                key={column.id}
                align={column.align}
                style={{ minWidth: column.minWidth }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell colSpan={columns.length + 1} align="center" style={{ padding: "40px" }}>
                <CircularProgress />
                <Box style={{ color: "#666", marginTop: "16px" }}>
                  {searchTerm ? "Searching challans..." : "Loading challans..."}
                </Box>
              </TableCell>
            </TableRow>
          ) : data.length === 0 ? (
            <TableRow>
              <TableCell colSpan={columns.length + 1} align="center" style={{ padding: "40px" }}>
                <Box style={{ color: "#666" }}>
                  {searchTerm ? "No challans found matching your search." : "No challans found."}
                </Box>
              </TableCell>
            </TableRow>
          ) : (
            data
              // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                return <RenderTableRow {...props} row={row} />;
              })
          )}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        // count={data.length}
        count={tota}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <InvoiceSelectionDialog />
      <MultipleAddressDialog />

      {openAccountViewDialog ? (
        <AccountView
          open={openAccountViewDialog.open}
          close={closeAccountViewDialog}
          item={openAccountViewDialog.item}
        />
      ) : null}
      {openAccountAddressDialog ? (
        <AccountAddress
          open={openAccountAddressDialog.open}
          close={closeAccountAddressDialog}
          account={openAccountAddressDialog.account}
          sender={openAccountAddressDialog.sender}
        />
      ) : null}
      {/*<Fab color="primary" aria-label="add" className={classes.fab}*/}
      {/*     onClick={() => setOpenAddDialog(true)}>*/}
      {/*    <AddIcon/>*/}
      {/*</Fab>*/}
      {openViewDialog ? (
        <ChallanView
          open={openViewDialog.open}
          close={closeViewDialog}
          item={openViewDialog.item}
        />
      ) : null}
      {openAddDialog ? (
        <ChallanAddDialog
          open={openAddDialog}
          close={closeAddDialog}
          readyMasterRange={readyMasterRange}
          showPrintModal={showPrintModal}
        />
      ) : null}

      {openDCDialog ? (
        <ChallanDCDialog
          open={openDCDialog}
          close={closeDCDialog}
          data={data}
          selectedRows={selectedRows}
        />
      ) : null}
      {openEditDialog ? (
        <ChallanEditDialog
          open={openEditDialog.open}
          close={closeEditDialog}
          item={openEditDialog.item}
          showPrintModal={showPrintModal}
          readyMasterRange={readyMasterRange}
        />
      ) : null}
      {openConfirmationDialog ? (
        <ConfirmationDialog
          open={openConfirmationDialog}
          onClose={() => setOpenConfirmationDialog(false)}
          onConfirm={() => _deleteItem(selectedChallan)}
          title={"Delete Record"}
          msg={"Do you want to delete this record?"}
        />
      ) : null}
      <ImportExcel
        db={"challans"}
        open={openImportDialog}
        close={() => setOpenImportDialog(false)}
      />
    </>
  );
}, (prevProps, nextProps) => {
  // Custom comparison function to prevent unnecessary re-renders
  return (
    prevProps.searchTerm === nextProps.searchTerm &&
    prevProps.filter === nextProps.filter &&
    prevProps.readyMasterRange === nextProps.readyMasterRange
  );
});
